var n = Object.defineProperty, c = Object.defineProperties;
var f = Object.getOwnPropertyDescriptors;
var i = Object.getOwnPropertySymbols;
var p = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
var t = (e, r, o) => r in e ? n(e, r, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[r] = o, a = (e, r) => {
  for (var o in r || (r = {}))
    p.call(r, o) && t(e, o, r[o]);
  if (i)
    for (var o of i(r))
      l.call(r, o) && t(e, o, r[o]);
  return e;
}, m = (e, r) => c(e, f(r));
import s, { forwardRef as g } from "react";
import d from "../lib/IconBase.mjs";
import w from "../defs/WarningCircle.mjs";
const C = g((e, r) => /* @__PURE__ */ s.createElement(d, m(a({ ref: r }, e), { weights: w })));
C.displayName = "WarningCircle";
export {
  C as WarningCircle
};
